// eslint-disable-next-line no-unused-vars
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {WINDOW, IS_MOBILE} from '../../constants/environment';
import Wrapper from '../../components/wrapper';
import './styles.css';

//import { getComponents } from '../../utils'
import Video from '../../blocks/video';
import Promo from '../../containers/promo';
import PromoAndButtonModalWindow from '../../blocks/promo-and-button-modal-window';
import * as blocks from '../../blocks';
import Wysiwyg from "../wysiwyg";

/**
 * three columns
 * @param {?string} containerId - ブロックにID属性を付与
 * @param {?string} containerClass - ブロックにCLASS属性を付与
 * @param {?string} anchorPoint - ブロックにアンカーを設定（ID属性の値として設定）
 * @param {?string} anchorName - アンカーナビに表示するラベル
 * @param {?string} backgroundColor - 背景色
 * @param {?string} size - 1カラムの場合はGutterを選んでもDividerになる。MBはFull-Width以外の場合はPaddingをつけて表示する（Full-Width / Divider / Vertical-Padding / Gutter / Horizontal-Padding / Padding）
 * @param {?string} mbLayout - モバイル時のレイアウト方法（Horizontal / Vertical）
 * @param {?boolean} resetUpperMargin - trueで上付きマージンを解除
 * @param {?boolean} setLowerMargin - trueで下付きマージンを付与
 * @param {?boolean} nested - レイアウトブロックの入れ子の子として設定されている場合はtrueとし、その場合マージンをネストジのマージンとする。通常はfalse。
 * @param {?Array<Component>} firstContent - 3カラム第1コンテンツ。Promo・Video・WYSIWYG・HTMLなどあらゆるブロックを設定可能。複数設定すると上から表示
 * @param {?Array<Component>} secondContent - 3カラム第2コンテンツ。Promo・Video・WYSIWYG・HTMLなどあらゆるブロックを設定可能。複数設定すると上から表示
 * @param {?Array<Component>} thirdContent - 3カラム第3コンテンツ。Promo・Video・WYSIWYG・HTMLなどあらゆるブロックを設定可能。複数設定すると上から表示
 * @returns {?ReactElement} `div.ThreeColumnLayout`
 */
export default class ThreeColumnLayout extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    backgroundColor: PropTypes.string,
    size: PropTypes.string,
    mbLayout: PropTypes.string,
    resetUpperMargin: PropTypes.bool,
    setLowerMargin: PropTypes.bool,
    nested: PropTypes.bool,
    firstContent: PropTypes.array,
    secondContent: PropTypes.array,
    thirdContent: PropTypes.array,
    // firstContent: PropTypes.arrayOf(PropTypes.node),
    // secondContent: PropTypes.arrayOf(PropTypes.node),
    // thirdContent: PropTypes.arrayOf(PropTypes.node)
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    backgroundColor: null,
    size: null,
    mbLayout: null,
    resetUpperMargin: null,
    setLowerMargin: null,
    nested: null,
    firstContent: null,
    secondContent: null,
    thirdContent: null,
  };

  constructor(props) {
    super();
    this.props = props;
    this.components = [];
    this.onResize = this.onResize.bind(this);
    this.timer = {
      fitHeight: 0,
    };
    this.intervalId = null;
  }
  onResize() {
    this.clearMaxHeight();
    this.delayGetAndSetMaxHeight();
  }
  clearMaxHeight() {
    this.components
      .filter(component => (component && component.clearContainerHeight))
      .map(component => (component.clearContainerHeight()));
  }
  delayGetAndSetMaxHeight(delay = 16 * 10) {
    clearTimeout(this.timer.fitHeight);
    this.timer.fitHeight = setTimeout(() => {
      this.getAndSetMaxHeight();
    }, delay);
  }
  getAndSetMaxHeight() {

    // if (IS_MOBILE && this.props.mbLayout === 'Two-Line') {
    //
    //   let components = [];
    //   this.components.map((component, index)=> {
    //     if (1 <= index) {
    //       components.push(component);
    //     }
    //   });
    //   const results = components
    //     .map(component => {
    //       if (component && component.getContentsHeight) {
    //         return component.getContentsHeight();
    //       }
    //       return 0;
    //     });
    //   results.sort((a, b) => (b - a));
    //   const maxHeight = results[0];
    //   components
    //     .filter(component => (component && component.setContainerHeight))
    //     .map(component => (component.setContainerHeight(maxHeight)));
    //
    // } else {

      const results = this.components
        .map(component => {
          if (component && component.getContentsHeight) {
            return component.getContentsHeight();
          }
          return 0;
        });
      results.sort((a, b) => (b - a));
      const maxHeight = results[0];
      this.components
        .filter(component => (component && component.setContainerHeight))
        .map(component => (component.setContainerHeight(maxHeight)));

    // }
  }
  getNestedComponents = (components, hasBackground = false, index2) => {
    return (
      components.map((component, index) => {
        let name = null;
        if (component.name) {
          name = component.name;
        } else if (component.type) {
          name = component.type.displayName.replace('Connect(', '').replace('withDynamicComponents(', '').replace(')', '').replace(')', '');
          // name = component.type.displayName.replace('withDynamicComponents(', '').replace(')', '');
        }
        // console.log(name)
        if (name === 'Video') {
          if (component.props.size) {
            component.props.size = 'Standard';
          }
          return (
            <Video
              {...component.props}
              key={index}
              getRef={(ref) => {

                // 配列の順番が変わってしまう不具合の対応
                if (IS_MOBILE && this.props.mbLayout === 'Two-Line' && index2 === 0) return null;

                (ref) ? this.components.push(ref): null;
              }}
              hasBackground={hasBackground}
              parentColumn='threeColumnLayout'
            />
          )
        } else if (name === 'Promo') {
          return (
            <Promo
              {...component.props}
              key={index}
              getRef={(ref) => {

                // 配列の順番が変わってしまう不具合の対応
                if (IS_MOBILE && this.props.mbLayout === 'Two-Line' && index2 === 0) return null;

                (ref) ? this.components.push(ref): null;
              }}
              hasBackground={hasBackground}
              parentColumn='threeColumnLayout'
            />
          )
        } else if (name === 'PromoAndButtonModalWindow') {
          return (
            <PromoAndButtonModalWindow
              {...component.props}
              key={index}
              getRef={(ref) => {

                // 配列の順番が変わってしまう不具合の対応
                if (IS_MOBILE && this.props.mbLayout === 'Two-Line' && index2 === 0) return null;

                (ref) ? this.components.push(ref): null;
              }}
              hasBackground={hasBackground}
              parentColumn='threeColumnLayout'
            />
          )
        } else if (name === 'Wysiwyg') {
          return (
            <Wysiwyg {...component.props}
                     key={index}
                     parentColumn='threeColumnLayout'
            />
          )
        }
        // else {
        //   let Block = blocks[name];
        //   if (Block) {
        //     return <Block {...component.props} key={index}/>
        //   } else {
        //     return null;
        //   }
        // }
        const Block = blocks[name];
        return Block ? <Block {...component.props} key={index}/> : null;
      })
    )
  };
  componentDidMount() {
    // window.addEventListener('resize', this.handleResize);
    // setTimeout(() => {
    //   this.handleResize();
    // }, 100)
    if (IS_MOBILE) {
      WINDOW.addEventListener('orientationchange', this.onResize, false);
    } else {
      WINDOW.addEventListener('resize', this.onResize, false);
    }
    this.onResize();

    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(()=> {
      this.getAndSetMaxHeight();
    }, 500);

  };

  componentWillUnmount() {
    // window.removeEventListener('resize', this.handleResize);
    if (IS_MOBILE) {
      WINDOW.removeEventListener('orientationchange', this.onResize);
    } else {
      WINDOW.removeEventListener('resize', this.onResize);
    }
    Object.values(this.timer).map(id => (clearTimeout(id)));

    if (this.intervalId) clearInterval(this.intervalId);

  }

  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      backgroundColor,
      size,
      mbLayout,
      resetUpperMargin,
      setLowerMargin,
      nested,
      firstContent,
      secondContent,
      thirdContent,
    } = this.props;
    // require check
    // firstContent / secondContent / thirdContent 必須
    const firstComponents = Array.isArray(firstContent) ? firstContent: [];
    const secondComponents = Array.isArray(secondContent) ? secondContent: [];
    const thirdComponents = Array.isArray(thirdContent) ? thirdContent: [];
    if (!firstComponents.length && !secondComponents.length && !thirdComponents.length) {
      return null;
    }
    // ---
    const baseClass = 'ThreeColumnLayout';
    const sizeClass = `size__${(size || 'Full-Width').toLowerCase()}`;
    const mbLayoutClass = `mbLayout__${(mbLayout || 'Horizontal').toLowerCase()}`;
    const upperMargin = resetUpperMargin ? 'ThreeColumnLayout__resetUpperMargin': '';
    const lowerMargin = setLowerMargin ? 'ThreeColumnLayout__setLowerMargin': '';
    const nestedClass = nested ? 'ThreeColumnLayout__nested': '';
    const classes = [
      baseClass,
      sizeClass,
      mbLayoutClass,
      upperMargin,
      lowerMargin,
      nestedClass,
    ];
    const attributes = {
      className: classes.filter(cssClass => (cssClass)).join(' '),
    };
    // ---
    // this.components = [];
    // const getNestedComponents = (components, hasBackground = false) => {
    //   return (
    //     components.map((component, index) => {
    //       let name = null;
    //       if (component.name) {
    //         name = component.name;
    //       } else if (component.type) {
    //         name = component.type.displayName.replace('withDynamicComponents(', '').replace(')', '');
    //       }
    //       if (name === 'Video') {
    //         if (component.props.size) {
    //           component.props.size = 'Standard';
    //         }
    //         return (
    //           <Video {...component.props}
    //                  key={index}
    //                  getRef={(ref) => {
    //                    (ref) ? this.components.push(ref): null;
    //                  }}
    //                  hasBackground={hasBackground}
    //                  parentColumn='threeColumnLayout'
    //           />
    //         )
    //       } else if (name === 'Promo') {
    //         return (
    //           <Promo {...component.props}
    //                  key={index}
    //                  getRef={(ref) => {
    //                    (ref) ? this.components.push(ref): null;
    //                  }}
    //                  hasBackground={hasBackground}
    //                  parentColumn='threeColumnLayout'
    //           />
    //         )
    //       }
    //       // else {
    //       //   let Block = blocks[name];
    //       //   if (Block) {
    //       //     return <Block {...component.props} key={index}/>
    //       //   } else {
    //       //     return null;
    //       //   }
    //       // }
    //       const Block = blocks[name];
    //       return Block ? <Block {...component.props} key={index}/> : null;
    //     })
    //   )
    // };
    // ---
    // console.log('ThreeColumnLayout.render', this.props);
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <div id={anchorPoint} data-anchor-name={anchorName}>
          <div {...attributes}>
            <div className="ThreeColumnLayout__container">
              <div className="ThreeColumnLayout__column ThreeColumnLayout__firstContent"
                   style={(backgroundColor && backgroundColor !== '') ? {backgroundColor: '#' + backgroundColor.replace(/#/g, '')}: null}
              >
                {this.getNestedComponents(firstComponents, (backgroundColor && backgroundColor !== '') ? true : false, 0)}
                {/*{getComponents(firstComponents)}*/}
                {/*{firstComponents}*/}
              </div>
              <div className="ThreeColumnLayout__column ThreeColumnLayout__secondContent"
                   style={(backgroundColor && backgroundColor !== '') ? {backgroundColor: '#' + backgroundColor.replace(/#/g, '')}: null}
              >
                {this.getNestedComponents(secondComponents, (backgroundColor && backgroundColor !== '') ? true : false, 1)}
                {/*{getComponents(secondComponents)}*/}
                {/*{secondComponents}*/}
              </div>
              <div className="ThreeColumnLayout__column ThreeColumnLayout__thirdContent"
                   style={(backgroundColor && backgroundColor !== '') ? {backgroundColor: '#' + backgroundColor.replace(/#/g, '')}: null}
              >
                {this.getNestedComponents(thirdComponents, (backgroundColor && backgroundColor !== '') ? true : false, 2)}
                {/*{getComponents(thirdComponents)}*/}
                {/*{thirdComponents}*/}
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
  //
  // //
  // handleResize = () => {
  //   let maxHeight = 0;
  //   let i, max;
  //   for (i = 0, max = this.components.length; i < max; i = i + 1) {
  //     const component = this.components[i];
  //     if (component && component.getContentsHeight) {
  //       const height = component.getContentsHeight();
  //       if (maxHeight < height) {
  //         maxHeight = height;
  //       }
  //     }
  //   }
  //   for (i = 0, max = this.components.length; i < max; i = i + 1) {
  //     const component = this.components[i];
  //     if (component && component.setContainerHeight) {
  //       component.setContainerHeight(maxHeight);
  //     }
  //   }
  // };

};



// WEBPACK FOOTER //
// ./src/containers/three-column-layout/index.jsx